import { AppContext } from '../global/models/app-context-model';
import { BaseTcsmEpiApiState } from '../global/models/epi-config-state-model';
import { DefaultSiteSettingsState, TcsmContentPropsState, TcsmEpiProps } from '../global/models/epi-model';
import { BaseAppState } from '../global/models/redux-state';
import { DependentsAppState } from '../pages/account-info/features/dependents/dependents-model';
import { DocumentUploadAppState } from '../pages/account-info/features/personal-info/document-upload-models';
import { PersonalInfoAppState } from '../pages/account-info/features/personal-info/personal-info-models';
import { RelationshipsAppState } from '../pages/account-info/features/relationships/relationships-model';
import { PersonalInfoProps, RelationshipsProps } from '../pages/account-info/models/account-info-epi-props';
import { BillingAccountsState } from '../pages/arc/features/billing-accounts/billing-accounts-models';
import { CompensationHistoryState } from '../pages/arc/features/compensation/compensation-history/compensation-history-model';
import { EmploymentState } from '../pages/arc/features/employment/employment-model';
import { InstitutionState } from '../pages/arc/features/institutions/institution-model';
import { PersonSearchAppState } from '../pages/arc/features/person-search/person-search-model';
import { AnnualEnrollmentProps, ClergyBioSettings, ClergyCompReportSettings, CompensationProps, EmploymentProps, GroupsBillingProps, GuidedProcessSupportProps, InstitutionProps, MapPortalProps, MidYearProps, NewHireProps, PensionEnrollmentProps, PersonSearchProps, SearchProps, TerminationProps } from '../pages/arc/models/arc-epi-props';
import { ParticipantsState } from '../pages/arc/features/participants/participants-models';
import { PaginationState } from '../pages/arc/shared-slices/pagination-model';
import { OfficerAdminState } from '../pages/arc/features/institution-officers/institution-officers-models';
import { GroupsState } from '../pages/arc/features/groups/groups-model';
import { AnnualEnrollmentAppState } from '../pages/annual-enrollment/models/annual-enrollment-models';
import { MidyearEnrollmentState } from '../pages/arc/features/mid-year/mid-year-model';
import { PensionEnrollmentState } from '../pages/arc/features/pension-enrollment/models/pension-enrollment-model';
import { DocumentDownloadState } from '../pages/arc/features/document-download/document-download-models';
import { NotificationState } from '../pages/notification/notification-models';
import { BasePageModel } from '../global/models/tcsm-page-models';
import { MyCpgPodsSettings, MyCpgPodsState } from '../pages/mycpg-pods/mycpg-pod-models';
import { EmploymentCompensationState } from '../pages/arc/features/employment-compensation/employment-compensation-models';
import { ReportAccessState } from '../pages/arc/features/report/models/report-models';
import { BackendSearchStates } from '../backend-search/models/search-models';
import { MyDocumentsState } from '../pages/my-documents/my-documents-models';
import { ClergyCompReportState } from '../pages/clergy-compensation-report/models';
import { ClergyBioAppState } from '../pages/clergy-bio/model/clergy-bio-app-models';
import { NewHireEnrollmentAppState } from '../pages/arc/features/new-hire-enrollment/models/new-hire-enrollment-models';
import { NewHireState } from '../pages/arc/features/new-hire/models/new-hire-state-model';
import { ParticipantEnrollmentSettings } from '../pages/arc/features/new-participant-enrollment/models/epi-props';
import { ParticipantEnrollmentAppState } from '../pages/arc/features/new-participant-enrollment/models/app-states';
import { BeneficiarySettings } from '../pages/arc/features/beneficiary/model/epi-props';
import { BeneficiaryState } from '../pages/arc/features/beneficiary/model/beneficiary-models';
import { MyCPGMidYearProps } from '../pages/account-info/features/mycpg-midyear/models/mycpg-midyear-epi-props';
import { MyCpgMidYearState } from '../pages/account-info/features/mycpg-midyear/models/mycpg-mid-year-models';
import { CicSettings } from '../pages/arc/features/cic-opt/model';

export interface TcsmEpiApiState extends BaseTcsmEpiApiState<TcsmEpiProps> {
	compensationSettingsState?: TcsmContentPropsState<CompensationProps>;
	employmentSettingsState?: TcsmContentPropsState<EmploymentProps>;
	institutionSettingsState?: TcsmContentPropsState<InstitutionProps>;
	searchSettingsState?: TcsmContentPropsState<SearchProps>;
	personSearchSettingsState?: TcsmContentPropsState<PersonSearchProps>;
	personalInfoSettingState?: TcsmContentPropsState<PersonalInfoProps>;
	relationshipsSettingState?: TcsmContentPropsState<RelationshipsProps>;
	groupsBillingSettingsState?: TcsmContentPropsState<GroupsBillingProps>;
	annualEnrollmentSettingsState?: TcsmContentPropsState<AnnualEnrollmentProps>;
	myCpgMidyearSettingsState?: TcsmContentPropsState<MyCPGMidYearProps>;
	pensionEnrollmentSettingsState?: TcsmContentPropsState<PensionEnrollmentProps>;
	newHireSettingsState?: TcsmContentPropsState<NewHireProps>;
	midYearSettingsState?: TcsmContentPropsState<MidYearProps>;
	terminationSettingsState?: TcsmContentPropsState<TerminationProps>;
	gpsSettingsState?: TcsmContentPropsState<GuidedProcessSupportProps>;
	mapPortalSettingsState?: TcsmContentPropsState<MapPortalProps>;
	pageData?: TcsmContentPropsState<BasePageModel>;
	podsSettingsState?: TcsmContentPropsState<MyCpgPodsSettings>;
	clergyCompReportSettingsState?: TcsmContentPropsState<ClergyCompReportSettings>;
	clergyBioSettingsState?: TcsmContentPropsState<ClergyBioSettings>;
	participantEnrollmentSettingsState?: TcsmContentPropsState<ParticipantEnrollmentSettings>;
	beneficiarySettingsState?: TcsmContentPropsState<BeneficiarySettings>;
	cicSettingsState?: TcsmContentPropsState<CicSettings>;
}

export const DefaultTcsmEpiProps: TcsmEpiProps = {
	// base
	pageTitle: '',
	apiResponseMessages: [],
};

export const DefaultTcsmEpiApiState: TcsmEpiApiState = {
	contentState: {
		contentLoaded: false,
		epiContent: DefaultTcsmEpiProps,
	},
	siteSettingsState: DefaultSiteSettingsState,
	compensationSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	labelSettingState: {
		contentLoaded: false,
		epiContent: null,
	},
	employmentSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	searchSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	personSearchSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	personalInfoSettingState: {
		contentLoaded: false,
		epiContent: null,
	},
	relationshipsSettingState: {
		contentLoaded: false,
		epiContent: null,
	},
	groupsBillingSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	annualEnrollmentSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	pensionEnrollmentSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	newHireSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	midYearSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	terminationSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	gpsSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	mapPortalSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	pageData: {
		contentLoaded: false,
		epiContent: null,
	},
	podsSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	beneficiarySettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
	cicSettingsState: {
		contentLoaded: false,
		epiContent: null,
	},
};

export interface TcsmStates extends BaseAppState {
	epiProps: TcsmEpiApiState,
	employmentState: EmploymentState,
	compensationHistoryState: CompensationHistoryState,
	institutionState: InstitutionState,
	paginationState: PaginationState,
	billingAccountsState: BillingAccountsState,
	participantState: ParticipantsState,
	personSearchState: PersonSearchAppState;
	personalInfo: PersonalInfoAppState;
	relationships: RelationshipsAppState;
	dependents: DependentsAppState;
	documentUpload: DocumentUploadAppState;
	groupsState: GroupsState;
	officerAdminState: OfficerAdminState;
	appContext: AppContext;
	annualEnrollment: AnnualEnrollmentAppState;
	midYearEnrollment: MidyearEnrollmentState;
	pensionEnrollmentState: PensionEnrollmentState;
	newHireState: NewHireState;
	documentDownload: DocumentDownloadState;
	notificationState: NotificationState;
	mycpgPodsState: MyCpgPodsState;
	employmentCompensationState: EmploymentCompensationState;
	reportAccessState: ReportAccessState;
	backendSearchStates: BackendSearchStates;
	myDocumentsState: MyDocumentsState;
	clergyCompReportState: ClergyCompReportState;
	clergyBioState: ClergyBioAppState;
	newHireEnrollmentState: NewHireEnrollmentAppState;
	participantEnrollmentState: ParticipantEnrollmentAppState;
	beneficiariesState: BeneficiaryState;
	myCpgMidYearState: MyCpgMidYearState;
}